import SameStoreSales from './SameStoreSales';
export default SameStoreSales;